import type { MetaFunction } from '@remix-run/node';

export const meta: MetaFunction = () => {
  return [
    { title: '이용약관 - 법무법인 휘상' },
    { name: 'description', content: '법무법인 휘상의 이용약관입니다.' },
  ];
};

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">이용약관</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-8">
            법무법인 휘상(이하 '회사')이 제공하는 서비스의 이용조건 및 절차, 회사와 이용자의
            권리·의무 및 책임사항을 규정함을 목적으로 합니다.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">제1조 (목적)</h2>
          <p className="text-gray-600 mb-8">
            이 약관은 회사가 제공하는 서비스의 이용조건 및 절차, 회사와 이용자의 권리·의무 및
            책임사항을 규정함을 목적으로 합니다.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">제2조 (정의)</h2>
          <p className="text-gray-600 mb-4">이 약관에서 사용하는 용어의 정의는 다음과 같습니다:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>'서비스'란 회사가 제공하는 모든 서비스를 말합니다.</li>
            <li>'이용자'란 회사의 서비스를 이용하는 고객을 말합니다.</li>
            <li>'계약'이란 서비스 이용을 위해 회사와 이용자 사이에 체결하는 계약을 말합니다.</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            제3조 (약관의 효력 및 변경)
          </h2>
          <p className="text-gray-600 mb-8">
            이 약관은 서비스를 이용하고자 하는 모든 이용자에 대하여 그 효력을 발생합니다. 회사는
            필요한 경우 약관을 변경할 수 있으며, 변경된 약관은 웹사이트에 공지함으로써 효력이
            발생합니다.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">제4조 (서비스의 제공)</h2>
          <p className="text-gray-600 mb-8">회사는 이용자에게 다음과 같은 서비스를 제공합니다:</p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>법률 상담 서비스</li>
            <li>법률 문서 작성 서비스</li>
            <li>법률 정보 제공 서비스</li>
            <li>기타 회사가 제공하는 서비스</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            제5조 (서비스 이용계약의 체결)
          </h2>
          <p className="text-gray-600 mb-8">
            서비스 이용계약은 이용자가 서비스 이용을 신청하고 회사가 이를 승낙함으로써 체결됩니다.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">제6조 (서비스 이용제한)</h2>
          <p className="text-gray-600 mb-8">
            회사는 이용자가 다음 각 호의 1에 해당하는 경우 서비스 이용을 제한할 수 있습니다:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>타인의 서비스 이용을 방해하거나 그 정보를 도용하는 경우</li>
            <li>
              서비스를 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
            </li>
            <li>서비스를 이용하여 타인에게 피해를 주거나 미풍양속을 해치는 행위를 하는 경우</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">제7조 (회사의 의무)</h2>
          <p className="text-gray-600 mb-8">
            회사는 서비스 제공과 관련하여 다음과 같은 의무를 가집니다:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>안정적인 서비스 제공을 위한 시스템 구축 및 유지</li>
            <li>이용자의 개인정보 보호</li>
            <li>서비스 이용과 관련된 이용자의 불만사항이 접수되는 경우 이를 신속하게 처리</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">제8조 (이용자의 의무)</h2>
          <p className="text-gray-600 mb-8">
            이용자는 서비스 이용과 관련하여 다음과 같은 의무를 가집니다:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>회사가 요구하는 개인정보를 정확하게 제공</li>
            <li>서비스 이용에 필요한 정보를 정확하게 입력</li>
            <li>서비스 이용에 관한 법령과 이 약관을 준수</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">제9조 (서비스 제공의 중단)</h2>
          <p className="text-gray-600 mb-8">
            회사는 다음 각 호의 1에 해당하는 경우 서비스 제공을 중단할 수 있습니다:
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-8">
            <li>시스템 점검, 보수, 교체 등의 경우</li>
            <li>전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우</li>
            <li>기타 불가항력적 사유가 있는 경우</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
            제10조 (준거법 및 관할법원)
          </h2>
          <p className="text-gray-600 mb-8">
            이 약관은 대한민국 법률에 따라 규율되고 해석됩니다. 서비스 이용으로 발생한 분쟁에 대해
            소송이 제기될 경우 회사의 본사 소재지를 관할하는 법원을 전속관할법원으로 합니다.
          </p>

          <div className="mt-12 text-right">
            <p className="text-gray-600">시행일자: 2024년 1월 1일</p>
          </div>
        </div>
      </div>
    </div>
  );
}
